import { component } from 'picoapp';
import { str2json } from '@utils';
const delegate = require('delegate');
import { timeline, animate } from 'motion';
import { enableBodyScroll, clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

export default component((node, ctx) => {
  class Modal extends HTMLElement {
    // static get observedAttributes() {
    //   return ['open'];
    // }

    constructor() {
      super();
      // console.log('Modal constructor', node, ctx);
    }

    connectedCallback() {
      this.isActive = false;
      this.identifier = this.dataset.identifier;
      this.init();
      this.initAnimations();
      this.bindEvents();
    }

    init() {
      this.modal = this;
      this.body = document.querySelector('body');
      this.pageWraper = document.querySelector('.Main');
      this.modalContent = this.querySelector('.Modal__content');
      this.modalBox = this.querySelector('.Modal__box');
      this.backdrop = this.querySelector('.backdrop');

      const defaults = {};

      const instanceOptions = str2json(this.dataset.options);
      const options = { ...defaults, ...instanceOptions };
    }

    initAnimations() { }

    bindEvents() {
      ctx.on('Modal', (state) => {
        console.log(state)
        if (state.identifier === this.identifier) {
          this[state.action]();
        }
      });

      if (this.backdrop) {
        this.backdrop.addEventListener('click', (e) => {
          this.toggle();
        });
      }

      delegate(
        this,
        '.closeModal',
        'click',
        (e) => {
          this.close();
        },
        false
      );

      // Close modal with ESC key
      // window.jQuery(document).keyup((e) => {
      //   if (e.keyCode == 27 && this.isActive) {
      //     // escape key maps to keycode `27`
      //     this.close();
      //   }
      // });
    }

    toggle() {
      if (this.isActive) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      const isActive = new CustomEvent('isActive');
      animate(this, { display: 'flex', zIndex: 90001, pointerEvents: 'auto' });
      const openSequence = [
        [this, { opacity: [0, 1] }, { duration: 0.4 }],
        [this.modalBox, { y: [100, 0], opacity: [0, 1] }, { duration: 0.7, at: '-0.2' }],
      ];
      timeline(openSequence).finished.then(() => {
        this.isActive = true;
        this.dispatchEvent(isActive);
        disableBodyScroll(this.modalContent);
        document.body.classList.add('has-modal-open');
      });
    }

    close() {
      const isInactive = new CustomEvent('isInactive');
      const closeSequence = [
        [this.modalBox, { y: 100, opacity: 0 }, { duration: 0.4 }],
        [this, { opacity: [1, 0] }, { duration: 0.3, at: '-0.2' }],
      ];
      timeline(closeSequence).finished.then(() => {
        animate(this, { display: 'none', pointerEvents: 'none' });
        this.isActive = false;
        this.dispatchEvent(isInactive);
        clearAllBodyScrollLocks();
        document.body.classList.remove('has-modal-open');
      });
    }
  }

  if (!customElements.get('modal-component')) {
    customElements.define('modal-component', Modal);
  }
});